import { render } from "./kyc.vue?vue&type=template&id=1ae0dc7e&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"

import "./kyc.vue?vue&type=style&index=0&id=1ae0dc7e&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae0dc7e"]])

export default __exports__